import React from 'react';
import { withAppBasename } from '../../config/appBase';

/**
 * A plain <a> for an app path that must keep full-page-load semantics (hash
 * scrolling, new tab, no Router context) but still land inside the /edu
 * prefix. Root-relative hrefs get the basename; "#x", "https://...",
 * "mailto:" and the like pass through untouched.
 */
const AppAnchor = React.forwardRef(function AppAnchor({ href, children, ...rest }, ref) {
  return (
    <a ref={ref} href={withAppBasename(href)} {...rest}>
      {children}
    </a>
  );
});

export default AppAnchor;
